
import { FemsGraph, MasterGraph,BemsGraph,ifacSecurityURL } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";

async function getFcmToken(userId,fcmToken) {
      const response = await Axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetUserFcmList/${userId},${fcmToken}`);
      return response;
    }

    const notificationRepository = {
        getFcmToken,
    };
    
    
    export default notificationRepository;